
import { defineComponent } from "vue";

export default defineComponent({
  name: "TabsRequisicion",
  props: {
    componenteIdPadre: String
  }
});
